<script lang="ts" setup>
import { replaceImgToBase64InHtml } from '@/utils/tools'
import { AdvTypeEnum, BannerTypeEnum, PositionTypeEnum } from '~/types/enumTypes'
import loadSvg from '@/assets/svg/image-loadding.gif'
import errorSvg from '@/assets/svg/image-error.svg'
import { openUrl, aTagOpenUrl, removeEventAdd } from '~/utils/openUrl'

const { showCenter, showSponsorCluster, isSponsoredAds } = storeToRefs(useAdvStore())
const { startMonitoring, closeCenter, closeClusterCenter } = useAdvStore()
const globalStor = useGlobalStore() as any
const {
  appData,
  advDomainList,
  curAdvDomain,
  showWordAnnouncement,
  showPicAnnouncement,
  showNameplateAnnouncement,
  isNanTong,
  sponsorObj,
  sponsorCluster
}: any = storeToRefs(globalStor)
const showRight = ref(false)
const showLeft = ref(false)
const isNone: any = ref(false)
// 右侧悬浮弹窗
const close = () => {
  showRight.value = false
  setTimeout(() => {
    isNone.value = true
  }, 700)
}
const closeLeft = () => {
  showLeft.value = false
}
// 最后操作时间
const lastActionTime = ref<number | null>(Date.now())
//获取路线切换广告图片域名
const domainUrl: any = computed(() => {
  if (curAdvDomain.value == JSON.stringify('{}')) return ''
  return curAdvDomain.value?.url || ''
})
// 获取 当前tab对象==> 右侧广告
const levitateObj: any = computed(
  () => appData.value?.advList?.[AdvTypeEnum.LEVITATE_ADV]?.[PositionTypeEnum.TOP]?.[BannerTypeEnum.BANNER]?.[0] || []
)
// 获取 当前tab对象==> 左侧广告
const levitateLeftObj: any = computed(() => {
  let data = null
  if (appData.value?.advList?.LEFT_LEVITATE_ADV?.TOP?.CONTRIBUTE?.[0]) {
    data = appData.value?.advList?.LEFT_LEVITATE_ADV?.TOP?.CONTRIBUTE?.[0]
  } else {
    data = appData.value?.advList?.LEFT_LEVITATE_ADV?.TOP?.BANNER?.[0]
  }
  return data
})
// 获取 当前tab对象==> 左侧跳转还是内容
const htmlJump: any = computed(() => {
  let data: boolean
  if (appData.value?.advList?.LEFT_LEVITATE_ADV?.TOP?.BANNER?.[0]) {
    data = false
  } else {
    data = true
  }
  return data
})

const LEFT_LEVITATE_ADV = ref('');
async function getLeftLevitateAdv() {
  let data = appData.value?.advList?.LEFT_LEVITATE_ADV?.TOP?.CONTRIBUTE?.[0] || ''
  if (data && data.content) {
    const decoded = decodeURIComponent(data.content);
    LEFT_LEVITATE_ADV.value = await replaceImgToBase64InHtml(decoded);
  }
}

watch(
  () => levitateObj.value,
  (val) => {
    if (val) {
      showRight.value = true
    }
  }
)

// // 判断是否展示右侧广告
// if (levitateObj?.value?.imgUrl) {
//   showRight.value = true
// }
watch(
  () => levitateLeftObj.value,
  (val) => {
    if (val) {
      showLeft.value = true
    }
  },
  { deep: true }
)
//点击广告跳转 ?.jumpUrl, sponsorObj?.id
const openJumpUrl = (imgeItem: any) => {
  if (process.client) {
    const { jumpUrl, id, name, category } = imgeItem
    trackAction(id, name, category) // 弹窗广告 打点
    if (jumpUrl) {
      let urlStr = decodeURIComponent(jumpUrl).replace(/amp;/g, '')
      openUrl(urlStr)
    } else {
      console.log('url异常')
    }
  }
}
const trackAction = (id: any, name = '', advType = '') => {
  trackEvent({ id: id, name: name, type: 'clklog', category: 'advertise', advertiseType: advType })
}

// 文字公告
const wordContent = ref('');
async function getWordContentBase64() {
  if (Array.isArray(appData.value?.placard) && curAdvDomain?.value) {
    // 确保 placard 是一个数组
    const list: any[] = appData.value.placard.filter((item: any) => item.category === 1 && item.type === 2)
    // 如果有符合条件的公告，解码并处理第一个公告的内容
    if (list.length > 0) {
      const decoded = decodeURIComponent(list?.[0]?.content || '');
      wordContent.value = await replaceImgToBase64InHtml(decoded);
    }
  }
}

// 图片公告
const picContent = computed(() => {
  if (Array.isArray(appData.value?.placard)) {
    // 确保 placard 是一个数组
    const list = (appData?.value?.placard).filter((item: any) => item.category === 2 && item.type == 3)
    // 如果有符合条件的公告，随机选择一个公告的内容
    if (list.length > 0) {
      const randomIndex = Math.floor(Math.random() * list.length) // 生成一个随机索引
      // 获取随机选中的公告
      return list[randomIndex]
    } else {
      return {}
    }
  } else {
    return {}
  }
})

// 铭牌广告
const nameplateContent = ref('');
async function getNameplateContent() {
  if (appData.value?.nameplate?.content) {
    const decoded = decodeURIComponent(appData.value?.nameplate?.content);
    nameplateContent.value = await replaceImgToBase64InHtml(decoded);
  }
}

onMounted(async () => {

  watch(() => curAdvDomain?.value,nVal => {
    if(nVal){
      getWordContentBase64();
      getNameplateContent();
      getLeftLevitateAdv();
    }
  })
  // 使用 watch 监听 appData 的变化
  watch(
    () => appData.value,
    (newVal) => {
      if (newVal && Object.keys(newVal).length > 0) {
        // 判断是否展示赞助商-横幅广告
        if (sponsorObj?.value?.imgUrl) {
          showCenter.value = true
        }
        // 判断是否展示赞助商-集群广告
        if (sponsorCluster?.value?.length) {
          showSponsorCluster.value = true
        }
        
        
      }
    },
    { immediate: true, deep: true }
  )

  // 监听文字公告
  watch(
    () => wordContent.value,
    (val) => {
      if (val) {
        globalStor.setWordAnnouncement(true)
      } else {
        globalStor.setWordAnnouncement(false)
      }
    }
  )

  // 监听图片公告
  watch(
    () => picContent.value,
    (val) => {
      if (val) {
        globalStor.setPicAnnouncement(true)
      } else {
        globalStor.setPicAnnouncement(false)
      }
    }
  )

  // 铭牌广告
  if (appData.value?.nameplate?.content) {
    globalStor.setNameplateAnnouncement(true)
  } else {
    globalStor.setNameplateAnnouncement(false)
  }

  isSponsoredAds.value = true
  aTagOpenUrl('adContent2')
  startMonitoring()
})
const subStr = (str: string) => {
  if (str.length > 5) {
    return str.substring(0, 5)
  }
  return str
}

// 左悬浮点击事件
const leftDialog = ref(false)
const leftClick = () => {
  // 判断弹窗还是跳转
  // levitateLeftObj
  if (htmlJump.value) {
    leftDialog.value = true
    trackAction(levitateLeftObj.value.id, levitateLeftObj.value.name, levitateLeftObj.value.category) // 弹窗广告 打点
    nextTick(() => {
      const wordCon = document.querySelector('.word-com') as unknown as HTMLElement
      if (wordCon) {
        // 获取所有的 ol li 元素
        const ol = wordCon.querySelectorAll('ol')
        const li = wordCon.querySelectorAll('li')
        // 遍历每个 li 元素，设置样式
        ol.forEach((item) => {
          item.style.listStyle = 'decimal' // 设置列表样式为数字
          item.style.listStylePosition = 'inside' // 设置列表项位置为内部
        })
        li.forEach((item) => {
          item.style.listStyle = 'decimal' // 设置列表样式为数字
          item.style.listStylePosition = 'inside' // 设置列表项位置为内部
        })
      }
    })
  } else {
    // 跳转
    if (process.client) {
      const { jumpUrl, id, name, category } = levitateLeftObj.value
      // const { jumpUrl, id, name, category } = imgeItem
      trackAction(id, name, category) // 弹窗广告 打点
      if (jumpUrl) {
        let urlStr = decodeURIComponent(jumpUrl).replace(/amp;/g, '')
        openUrl(urlStr)
      } else {
        console.log('url异常')
      }
    }
  }
}

// 在组件卸载前清理所有资源
onBeforeUnmount(() => {
  // 清理 DOM 事件
  removeEventAdd('adContent2')

  // 清理引用
  showRight.value = false
  showLeft.value = false
  leftDialog.value = false

  // 清理图片缓存引用
  if (process.client) {
    const images = document.querySelectorAll('img')
    images.forEach((img) => {
      img.src = ''
      img.remove()
    })
  }
})

const openAUrl = (e: any) => {
  let target = e.target
  // 向上遍历直到找到 <a> 标签
  while (target && target.tagName !== 'A') {
    target = target.parentElement
  }
  if (target && target.tagName === 'A') {
    // 找到 <a> 标签，获取 href 属性
    e.preventDefault()
    openUrl(target.href)
  }
}
const showMingPai = () => {
  let result = false
  if (showNameplateAnnouncement.value) {
    if (nameplateContent.value && nameplateContent.value != 'undefined') {
      result = true
    }
  }
  return result
}
</script>

<template>
  <!-- 赞助商广告 -->
  <van-overlay :show="showCenter && isSponsoredAds && !!sponsorObj?.imgUrl" z-index="14" @click="closeCenter">
    <div :class="{ animate__backInDown: showCenter && isSponsoredAds && sponsorObj?.imgUrl }"
      class="hk-center sponsorships-dialog keep-px" stype="max-width:720px;">
      <div class="hk-dialog-con" style="min-height: 200px; max-height: 350px">
        <ImageWrap :adInfo="sponsorObj" style="min-height: 200px; max-height: 350px"
          :src="domainUrl + sponsorObj?.imgUrl" fit="cover" height="100%" width="100%"
          @click.stop="openJumpUrl(sponsorObj)" />
      </div>
      <div class="action-con" @click="closeCenter">
        <SvgIcon v-if="isNanTong" name="closeX" class="close-icon w-[24px] close h-[24px]" />
        <van-icon v-else class="close-icon" name="close" />
      </div>
    </div>
  </van-overlay>
  <!-- 赞助商-集群广告 -->
  <van-overlay :show="showSponsorCluster && isSponsoredAds && sponsorCluster?.length > 0" z-index="10"
    @click="closeClusterCenter" style="background: rgba(0, 0, 0, 0.6); backdrop-filter: blur(5px)">
    <div class="sponsorcluster-dialog" v-if="showSponsorCluster && isSponsoredAds && sponsorCluster?.length">
      <SvgIcon v-if="isNanTong" @click="closeClusterCenter" name="closeX"
        class="sponsocr-close w-[24px] close h-[24px]" />
      <van-icon v-else class="sponsocr-close" name="close" @click="closeClusterCenter" />
      <div class="hkv-grid_wrap">
        <div class="hkv-item" v-for="item in sponsorCluster" :src="domainUrl + item?.imgUrl"
          @click.stop="openJumpUrl(item)">
          <div class="pic">
            <ImageWrap :adInfo="item" height="100%" width="100%" :src="domainUrl + item?.imgUrl" fit="cover" />
          </div>
          <div class="name">{{ subStr(item?.name) }}</div>
        </div>
      </div>
    </div>
  </van-overlay>

  <!-- 文字公告弹窗 -->
  <van-overlay :show="!!showWordAnnouncement && wordContent != 'undefined' && !!wordContent" z-index="12"
    @click="globalStor.setWordAnnouncement(false)">
    <div v-show="showWordAnnouncement && wordContent != 'undefined' && wordContent"
      :class="{ animate__backInUp: showWordAnnouncement }" class="hkg-dialog word-dialog">
      <div class="hk-dialog-con word-con">
        <ClientOnly>
          <div v-html="wordContent" id="adContent2"></div>
        </ClientOnly>
      </div>
      <div class="action-con" @click="globalStor.setWordAnnouncement(false)">
        <SvgIcon v-if="isNanTong" name="closeX" class="close-icon w-[24px] close h-[24px]" />
        <van-icon v-else class="close-icon" name="close" />
      </div>
    </div>
  </van-overlay>

  <!-- 图片公告弹窗 -->
  <van-overlay v-if="picContent?.url" :show="showPicAnnouncement && !showWordAnnouncement" z-index="11"
    @click="globalStor.setPicAnnouncement(false)">
    <div :class="{ animate__backInLeft: showPicAnnouncement }" class="hkg-dialog pic-dialog">
      <div class="hk-dialog-con">
        <div>
          <ImageWrap :adInfo="picContent" style="min-height: 100px" v-if="picContent?.url" height="100%" width="100%"
            @click="openJumpUrl(picContent)" :src="domainUrl + picContent?.url" fit="cover" />
        </div>
      </div>
      <div class="action-con" @click="globalStor.setPicAnnouncement(false)">
        <SvgIcon v-if="isNanTong" name="closeX" class="close-icon w-[24px] close h-[24px]" />
        <van-icon v-else class="close-icon" name="close" />
      </div>
    </div>
  </van-overlay>

  <!-- 铭牌弹窗 -->
  <van-overlay :show="showMingPai()" z-index="9" @click="globalStor.setNameplateAnnouncement(false)">
    <div v-show="showMingPai()" :class="{ animate__backInDown: showNameplateAnnouncement }"
      class="hkg-dialog nameplate-dialog keep-px" stype="max-width:720px;">
      <div class="hk-dialog-con word-con">
        <div v-if="!nameplateContent.includes('undefined')" v-html="nameplateContent"></div>
      </div>
      <div class="action-con" @click="globalStor.setNameplateAnnouncement(false)">
        <SvgIcon v-if="isNanTong" name="closeX" class="close-icon w-[24px] close h-[24px]" />
        <van-icon v-else class="close-icon" name="close" />
      </div>
    </div>
  </van-overlay>

  <!-- 右侧广告 -->
  <div v-if="showRight && levitateObj?.imgUrl" :class="{ animate__backOutDown: !showRight }"
    class="hk-right animate__bounceIn">
    <div v-if="!isNanTong" class="action-con right-slide">
      <van-icon class="close-icon" name="close" @click="close" />
    </div>
    <div class="hk-dialog-con">
      <ImageWrap :adInfo="levitateObj" height="100%" width="100%" @click="openJumpUrl(levitateObj)" fit="cover"
        v-if="levitateObj?.imgUrl && domainUrl" :src="domainUrl + levitateObj?.imgUrl" />
    </div>
    <div v-if="isNanTong" class="closeBtn" @click="close">点击关闭</div>
  </div>

  <!-- 左侧广告 showLeft -->
  <div v-show="showLeft && levitateLeftObj?.imgUrl && domainUrl" class="hk-left animate__bounceIn">
    <div v-if="!isNanTong" class="action-con left-slide">
      <van-icon class="close-icon" name="close" @click="closeLeft" />
    </div>
    <div class="hk-dialog-con">
      <ImageWrap :adInfo="levitateLeftObj" height="100%" width="100%" @click="leftClick" fit="cover"
        :src="domainUrl + levitateLeftObj?.imgUrl" />
    </div>
    <div v-if="isNanTong" class="closeBtn" @click="closeLeft">点击关闭</div>
  </div>
  <!-- 左侧广告点击后弹窗 -->
  <van-dialog :closeOnClickOverlay="true" style="padding: 10px; --van-dialog-background: #ffffff"
    v-model:show="leftDialog" title="" :show-confirm-button="false">
    <div style="height: 60vh; overflow-y: auto">
      <div class="word-com" @click="openAUrl" style="min-height: 100px; color: #333; list-style: decimal"
        v-html="LEFT_LEVITATE_ADV"></div>
    </div>
    <div @click="leftDialog = false" style="text-align: center; margin-top: 20px; color: #333">
      <div v-if="isNanTong" class="flex justify-center items-center">
        <SvgIcon name="closeX" class="w-[24px] close h-[24px]" />
      </div>
      <van-icon v-else size="24" name="close" />
    </div>
  </van-dialog>
</template>

<style lang="scss" scoped>
:deep(.pic-dialog .van-image__error),
:deep(.sponsorships-dialog .van-image__error) {
  background-color: #242b34;
  height: 150px;

  img {
    object-fit: cover;
  }
}

.sponsorcluster-dialog {
  left: 50%;
  top: 50%;
  position: fixed;
  display: flex;
  justify-content: center;
  transform: translate(-50%, -50%);
  z-index: 122;

  .adv-grid_wrap {
    display: grid;
    max-height: 400px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 15px;
    width: 100%;
  }

  .sponsocr-close {
    position: absolute;
    font-size: 28px;
    z-index: 11;
    bottom: -80px;
  }
}

.adv-item {
  display: flex;
  flex-direction: column;

  .pic {
    height: 62px !important;
    width: 62px;
    border-radius: 15px;
    overflow: hidden;
  }

  .name {
    color: #fff;
    font-size: 11px;
    padding-top: 7px;
    text-align: center;
    white-space: nowrap;
  }
}

.none {
  display: none;
}

.ad-dialog-con {
  :deep(.van-image__img) {
    border-radius: 15px;
  }
}

:deep(h1, h2, h3, h4, h5, h6) {
  font-size: revert !important;
}

.ad-right {
  position: fixed;
  bottom: 20%;
  right: 0;
  width: 86px;
  max-width: 86px;
  height: 86px;
  max-height: 86px;
  z-index: 1000;

  .ad-dialog-con {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    overflow: hidden;
  }

  .action-con {
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(.van-icon-close:before) {
      font-size: 24px;
    }
  }
}

.ad-left {
  position: fixed;
  bottom: 20%;
  left: 0;
  width: 86px;
  max-width: 86px;
  height: 86px;
  max-height: 86px;
  z-index: 1000;

  .ad-dialog-con {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    overflow: hidden;
  }

  .action-con {
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(.van-icon-close:before) {
      font-size: 24px;
    }
  }
}

.ad-center {
  position: fixed;
  top: 30%;
  width: 263px;
  max-width: 450px;
  max-height: 360px;
  z-index: 12;
  left: 50%;
  transform: translateX(-50%);

  .ad-dialog-con {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
  }

  .action-con {
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(.van-icon-close:before) {
      font-size: 24px;
    }
  }
}

.gg-dialog {
  border-radius: 15px;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 6;
  top:50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 263px;
  max-width: 450px;
  max-height: calc(100vh - 30px);
  display: flex;
  // text-align: center;
  align-items: center;
  flex-direction: column;

  .ad-dialog-con {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    // overflow: hidden;
  }

  .action-con {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -30px;

    :deep(.van-icon-close:before) {
      font-size: 24px;
    }
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 5;
}

.word-con {
  padding: 10px;
  min-height: 180px;
  max-height: 50vh;
  overflow: auto;
}

.sponsorships-dialog {
  z-index: 15;
}

.word-dialog {
  z-index: 13;
}

.pic-dialog {
  z-index: 12;
}

.nameplate-dialog {
  z-index: 10;
}

ol,
li {
  list-style: decimal;
  list-style-position: inside;
}

.nantong {
  .closeBtn {
    height: 16px;
    color: #fff;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    width: 100%;
    line-height: 16px;
    background-color: black;
    text-align: center;
  }

  .ad-left,
  .ad-right {
    width: 80px;
    height: 80px;

    background-color: white;
    box-sizing: border-box;

    .ad-dialog-con {
      border-radius: 0px;

      :deep(.van-image__img) {
        padding: 2px;
        width: 100%;
        border-radius: 0px;
      }
    }
  }
}
</style>
